import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
// --- Import redux
import { connect } from "react-redux";
// --- Import hooks
import readCookie from "../../hooks/readCookie";
import getQueryParams from "../../hooks/getQueryParams";
import createCookie from "../../hooks/createCookie";

// --- Import BLL
import { setAuthStatus } from "../../store/actionCreators/userDataActionCreator";
import {
  initialize,
  setCookieExisted,
} from "../../store/actionCreators/appActionCreator";
// --- Import components
import Preloader from "../UI/Preloader/Preloader";
import Portal from "../UI/Portal/Portal";

function UserData({
  initialized,
  setIsAuth,
  setCookie,
  setInitialized,
  isAuth,
  cookieExisted,
  userDataError,
  children,
}) {
  const history = useHistory();
  const qs = getQueryParams(history.location.search);

  useEffect(() => {
    if (qs.guid) {
      createCookie("guid", qs.guid, 365);
    }
  }, [qs]);

  useEffect(() => {
    if (qs.aAuth !== undefined && qs.aAuth !== "") {
      createCookie("aAuth", qs.aAuth, 365);
    }
    if (readCookie("aAuth") !== "" && readCookie("aAuth") !== null) {
      setCookie(true);
      setInitialized();
      if (userDataError === "") {
        setIsAuth(true);
      } else {
        setIsAuth(false);
      }
    }
  }, [cookieExisted, userDataError]);

  return isAuth && !initialized ? (
    <Portal>
      <Preloader height="100vh" width="125px" />
    </Portal>
  ) : (
    children
  );
}
UserData.propTypes = {
  setIsAuth: PropTypes.func.isRequired,
  setInitialized: PropTypes.func.isRequired,
  setCookie: PropTypes.func.isRequired,
  // data
  isAuth: PropTypes.bool.isRequired,
  initialized: PropTypes.bool.isRequired,
  userDataError: PropTypes.string.isRequired,
  cookieExisted: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

const mapDispatchToProps = {
  setIsAuth: setAuthStatus,
  setInitialized: initialize,
  setCookie: setCookieExisted,
};

const mapStateToProps = (state) => {
  return {
    initialized: state.appStore.initialized,
    cookieExisted: state.appStore.cookieExisted,
    isAuth: state.userDataStore.isAuth,
    userDataError: state.userDataStore.userDataError,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserData);
